<script lang="ts" setup>
import OmniTooltip from "@/components/omni/OmniTooltip.vue";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto";
import { computed } from "vue";
import { useBaseView } from "@/composables";
import { useI18n } from "vue-i18n";

const { hasAccess } = useBaseView();
const { t } = useI18n();

const hasAccessToView = computed(() => {
  return hasAccess(DispatcherPermissionValue.ViewUserInfo);
});

const props = defineProps<{
  id: string | number;
}>();
</script>

<template>
  <omni-tooltip :disabled="hasAccessToView">
    <template #activator>
      <v-btn
        :disabled="!hasAccessToView"
        :to="{ name: 'user-view', params: { id: props.id } }"
        class="pa-1 view-user-button"
        flat
        size="small"
        variant="text"
      >
        <v-icon
          :class="{
            'text-grey-darken-4': !hasAccessToView,
            'text-primary': hasAccessToView,
          }"
          >mdi-eye-outline</v-icon
        >
      </v-btn>
    </template>

    {{ t("permission.user-details") }}
  </omni-tooltip>
</template>

<style lang="scss" scoped>
.view-user-button {
  width: auto !important;
  min-width: auto !important;
  padding: 0 2px !important;
  background: transparent !important;

  &:not(:last-child) {
    margin-right: 10px;
  }
}
</style>
